module.exports = __webpack_public_path__ + "static/img/alarm-notify-icon.10174582.svg";